module.exports = __webpack_public_path__ + "static/media/technology-stack.4038dde5.svg";